<mat-card class="child-form-container">
  <h4>{{ 'ADDRESS.ADDRESS' | translate }}</h4>

  <div class="form-row" [formGroup]="form">
    <mat-form-field appearance="outline" [class.readonly-field]="viewMode">
      <mat-label>{{ 'ADDRESS.STREET_ADDRESS' | translate }}<span class="required-asterisk"> *</span></mat-label>
      <input appCapitalizeFirst type="text" [readonly]="viewMode" [maxLength]="50" matInput formControlName="streetAddress" />
      @if (form.get('streetAddress')?.hasError('required')) {
        <mat-error>{{ 'COMMON.REQUIRED' | translate }}</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" [class.readonly-field]="viewMode">
      <mat-label>{{ 'ADDRESS.SUBURB' | translate }}</mat-label>
      <input appCapitalizeFirst type="text" [readonly]="viewMode" [maxLength]="50" matInput formControlName="suburb" />
    </mat-form-field>

    <mat-form-field appearance="outline" [class.readonly-field]="viewMode">
      <mat-label>{{ 'ADDRESS.CITY' | translate }}</mat-label>
      <input appCapitalizeFirst type="text" [readonly]="viewMode" [maxLength]="20" matInput formControlName="city" />
    </mat-form-field>

    <mat-form-field appearance="outline" [class.readonly-field]="viewMode">
      <mat-label>{{ 'ADDRESS.POSTCODE' | translate }}</mat-label>
      <input type="text" [readonly]="viewMode" [maxLength]="6" matInput formControlName="postCode" />
    </mat-form-field>

    @if (viewMode) {
      <div formGroupName="state">
        <mat-form-field appearance="outline" [class.readonly-field]="viewMode" formGroupName="country">
          <mat-label>{{ 'ADDRESS.COUNTRY' | translate }}</mat-label>
          <input type="text" [readonly]="viewMode" matInput formControlName="name" />
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" [class.readonly-field]="viewMode" formGroupName="state">
        <mat-label>{{ 'ADDRESS.STATE' | translate }}<span class="required-asterisk"> *</span></mat-label>
        <input type="text" [readonly]="viewMode" matInput formControlName="name" />
      </mat-form-field>
    }

    @if (!viewMode) {
      <div formGroupName="state">
        <mat-form-field appearance="outline" formGroupName="country">
          <mat-label>{{ 'ADDRESS.COUNTRY' | translate }}</mat-label>
          <mat-select (selectionChange)="onCountryChange()" formControlName="id">
            <mat-option>
              <ngx-mat-select-search [formControl]="countryFilterCtrl" [placeholderLabel]="'COMMON.SEARCH' | translate"></ngx-mat-select-search>
            </mat-option>
            @for (country of filteredCountries(); track country.id) {
              <mat-option [value]="country.id">{{ countryService.getCountryLabel(country) }}</mat-option>
            }
            @if (filteredCountries().length === 0) {
              <mat-option disabled>{{ 'COMMON.NO_OPTIONS' | translate }}</mat-option>
            }
          </mat-select>
          @if (form.get('state.country.id')?.value) {
            <button tabindex="-1" type="button" (click)="sharedService.clear(form, 'state.country')" mat-icon-button matSuffix>
              <mat-icon>close</mat-icon>
            </button>
          }
          @if (form.get('country.id')?.hasError('required')) {
            <mat-error>{{ 'COMMON.REQUIRED' | translate }}</mat-error>
          }
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" formGroupName="state">
        <mat-label>{{ 'ADDRESS.STATE' | translate }}<span class="required-asterisk"> *</span></mat-label>
        <mat-select formControlName="id">
          @if (!form.get('state.country.id')?.value) {
            <mat-option disabled>{{ 'ADDRESS.SELECT_COUNTRY_FIRST' | translate }}</mat-option>
          }
          @if (form.get('state.country.id')?.value) {
            <mat-option>
              <ngx-mat-select-search [formControl]="stateFilterCtrl" [placeholderLabel]="'COMMON.SEARCH' | translate"></ngx-mat-select-search>
            </mat-option>
          }
          @for (state of filteredStates(); track state.id) {
            <mat-option [value]="state.id">{{ stateService.getStateLabel(state) }}</mat-option>
          }
          @if (form.get('state.country.id')?.value && filteredStates().length === 0) {
            <mat-option disabled>{{ 'COMMON.NO_OPTIONS' | translate }}</mat-option>
          }
        </mat-select>
        @if (form.get('state.id')?.value) {
          <button tabindex="-1" type="button" (click)="sharedService.clear(form, 'state')" mat-icon-button matSuffix>
            <mat-icon>close</mat-icon>
          </button>
        }
        @if (form.get('state.id')?.hasError('required')) {
          <mat-error>{{ 'COMMON.REQUIRED' | translate }}</mat-error>
        }
      </mat-form-field>
    }

    @if (!createMode && showActive) {
      <div class="status-button-group display-inline-start">
        <label for="status-toggle-group">{{ 'COMMON.STATUS' | translate }}<span class="required-asterisk"> *</span></label>
        <mat-button-toggle-group
          id="status-toggle-group"
          appearance="legacy"
          aria-label="active status"
          [hideSingleSelectionIndicator]="true"
          formControlName="active"
          matTooltip="{{ 'COMMON.STATUS' | translate }}"
        >
          <mat-button-toggle [class.active]="form.get('active')?.value" [value]="true">{{ 'COMMON.ACTIVE' | translate }}</mat-button-toggle>
          <mat-button-toggle [class.inactive]="!form.get('active')?.value" [value]="false">{{ 'COMMON.INACTIVE' | translate }}</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    }
  </div>
</mat-card>
